import { Injectable, Injector } from "@angular/core";
import { AuthenticationService, UserService } from "./auth/service";

@Injectable()
export class AppInitializerService {
  constructor(private injector: Injector) {}

  // * Evitar ingresar procesos aqui, solo acciones ligeras ya que pueden retrazar la carga de la app.
  executePreInitApp = (): Promise<void> =>
    new Promise(async (resolve) => {
      const user = this.injector.get(UserService);
      const auth = this.injector.get(AuthenticationService);
      /* const hostDB = await auth
        .getSaml2Config(window.location.hostname)
        .toPromise()
        .catch((err) => {
          console.error("get saml2 config failed: " + err);
        });

      if (hostDB && hostDB.enabled) {
        auth.showSaml2LoginSubject.next(true);
        auth.companySaml2IdSubject.next(hostDB.owner_id);
      } */

      console.info("APP INITIALIZE STARTED !!");
      const initialToken = auth.token;
      if (auth.isLogged)
        await user
          .authVerify()
          .toPromise()
          .catch((err) => {
            console.error("APP INITIALIZE AUTH error", err);
            const reason = err.details?.message;
            const error = err.details?.error;
            if (error === "Unauthorized" && auth.token === initialToken) auth.logout();
            resolve();
          });
      else {
        console.warn("APP INITIALIZE NOT LOGGED");
        auth.logout();
      }
      console.info("APP INITIALIZE RESOLVED");
      resolve();
    });
}
